import WIDGETS from './widgets.js';

export default {
  name: 'search_clients',
  spacing: 0,
  widgets: [
    { content: WIDGETS.REFERRAL_SEARCH_CLIENT, breakpoints: { xs: 12 }, lazy_loading: 0 },
  ],
};
